import { all } from '../services/restApi'
import { batchObject, batchArray } from '../services/batch'
import { message } from 'antd'
import config from '../utils/config'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'user',
	state : {
		users: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/all_users/list-users') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, '_User', {
					where: {
						type: 'administrador',
						objectId: {$ne: JSON.parse(localStorage.getItem('currentUser')).objectId}
					},
					skip: 0, limit: limit, count: 1, order: '-createdAt'
				})
				const users = resp.results;

				yield put({ type: 'queryFirst', payload: {
					users: users, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e.response && e.response.data) message.error(e.response.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, 
					where: {
						type: 'administrador',
						objectId: {$ne: JSON.parse(localStorage.getItem('currentUser')).objectId}
					},
				};

				const resp = yield call(all, '_User', data)
				const users = resp.results;

				yield put({ type: 'querySuccess', payload: {
					users: users,
					skip: data.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.response.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {
				// Model
				let data = {...payload};
		        data._method = "PUT";
				data = _.omit(data, ['createdAt', 'updatedAt']);

				yield call(batchObject, '_User', data.objectId, data)
				yield put({ type: 'updateSuccess', payload: {...data, objectId: payload.objectId} })
				message.success('Se ha actualizado el usuario exitosamente');

			} catch (e) {
				if (e.response && e.response.data) message.error(e.response.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				let data = {};
		        data.requests = [{method: "DELETE", path: "/"+ config.slug +"/classes/_User/" + payload.objectId}];

				yield call(batchArray, data);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e.response && e.response.data) message.error(e.response.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				users: state.users.concat(action.payload.users),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.users, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			users: _.without(state.users, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/user.js